export const formatDuration = (seconds: string | number | null | undefined): string => {
  if (seconds == null) {
    return '—';
  }
  const secs = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  if (Number.isNaN(secs)) {
    return '—';
  }
  const mins = Math.floor(secs / 60);
  const remainder = Math.round(secs % 60);
  return `${mins}m ${remainder}s`;
};
